// oauth.js - Centralized OAuth configuration for Pista
// Extracted to prevent drift across Login.jsx, OAuthCallback.jsx, and App.jsx

function getDefaultRedirectHostname() {
  const env = process.env.REACT_APP_OAUTH_REDIRECT_HOST;
  if (env) return env;

  const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
  if (frontendUrl) {
    try {
      return new URL(frontendUrl).host;
    } catch {
      // fall through
    }
  }

  if (typeof window !== 'undefined' && window.location && window.location.host) {
    const host = window.location.host;
    if (host && !host.includes('localhost') && !host.includes('127.0.0.1')) {
      return host;
    }
  }

  if (process.env.NODE_ENV === 'test') {
    // Provide a safe default in test/Jest environments so unit tests can load.
    return 'app.voyagerbug.com';
  }

  throw new Error(
    'REACT_APP_OAUTH_REDIRECT_HOST or REACT_APP_FRONTEND_URL must be set for OAuth redirect host.'
  );
}

function getDefaultCustomScheme() {
  const env = process.env.REACT_APP_OAUTH_CUSTOM_SCHEME;
  if (env) return env;

  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const hostname = window.location.hostname;
    if (hostname && (hostname === 'pista-test.pages.dev' || hostname.includes('pista-test'))) {
      return 'pista-test';
    }
  }

  return 'pista';
}

const OAUTH_REDIRECT_HOSTNAME = getDefaultRedirectHostname();
const OAUTH_CUSTOM_SCHEME = getDefaultCustomScheme();

export const OAUTH_CONFIG = {
  /** The custom URL scheme used by the mobile app to receive deep links */
  customScheme: OAUTH_CUSTOM_SCHEME,

  /** The OAuth callback path (both web and deep link) */
  callbackPath: '/oauth-callback',

  /** Full custom-scheme redirect URL: pista://oauth-callback */
  get customRedirectUrl() {
    return `${this.customScheme}://${this.callbackPath.replace(/^\//, '')}`;
  },

  /** The HTTPS web URL Google redirects to for mobile OAuth */
  get webRedirectUri() {
    return `https://${OAUTH_REDIRECT_HOSTNAME}${this.callbackPath}`;
  },

  /** Check whether the current URL is the web redirect page (mobile OAuth landing page) */
  isRedirectPage(url = window.location.href) {
    return url.includes(OAUTH_REDIRECT_HOSTNAME);
  },

  /** Check whether a URL uses the custom app scheme */
  isAppSchemeUrl(url) {
    return !!url && url.startsWith(`${this.customScheme}://`);
  },
};
